import React, { useState, useEffect } from "react";
import UniversalBack from "../../common/mobile/UniversalBack";
import NoData from "../../common/mobile/NoData";
import { Modal } from "react-bootstrap";  

function BettingRecord() {
    const [activeTab, setActiveTab] = useState("settle");
    const [providers, setProviders] = useState([]);
    const [gameTypes, setGameTypes] = useState([]);
    const [bettingRecords, setBettingRecords] = useState([]);
    const [exchangeRecords, setExchangeRecords] = useState([]);  // New state for exchange records
    const [selectedPlatform, setSelectedPlatform] = useState("All");
    const [selectedType, setSelectedType] = useState("All");
    const [selectedDate, setSelectedDate] = useState("Today");
    const [isCurrentTab, setIsCurrentTab] = useState(true);
    const [expandedGroup, setExpandedGroup] = useState(null);
    const [isGroupClicked, setIsGroupClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasLoaded, setHasLoaded] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [selectedExchangeRecord, setSelectedExchangeRecord] = useState(null);

    const expandedSummary = expandedGroup
  ? expandedGroup.records.reduce(
      (acc, record) => {
        acc.platform = record.platform;
        acc.gameType = record.game_type;
        acc.totalTurnover += parseFloat(record.bet_amount) || 0;
        acc.totalProfitLoss += (parseFloat(record.winAmount) || 0) - (parseFloat(record.bet_amount) || 0);
        return acc;
      },
      { platform: "", gameType: "", totalTurnover: 0, totalProfitLoss: 0 }
    )
  : null;


    const filterOpen = () => {
        document.querySelector('.searchpage').classList.add('active');
        document.querySelector('.searchpage-bar').classList.add('active');
    };

    const filterClose = () => {
        document.querySelector('.searchpage').classList.remove('active');
        document.querySelector('.searchpage-bar').classList.remove('active');
    };

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            try {
                setIsLoading(true);
                // Fetch all data in parallel
                const [providersResponse, typesResponse, recordsResponse, exchangeResponse] = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/api/get-provider`, { headers }),
                    fetch(`${process.env.REACT_APP_API_URL}/api/get-type`, { headers }),
                    fetch(`${process.env.REACT_APP_API_URL}/api/betting-record`, { headers }),
                    fetch(`${process.env.REACT_APP_API_URL}/api/exchange-hub`, { headers }),
                ]);
        
                if (providersResponse.ok && typesResponse.ok) {
                    const providersData = await providersResponse.json();
                    const typesData = await typesResponse.json();
                    setProviders(providersData.data);
                    setGameTypes(typesData.types);
                }
        
                if (recordsResponse.ok) {
                    const recordsData = await recordsResponse.json();
                    setBettingRecords(recordsData);
                } else {
                    setBettingRecords([]);
                }
        
                if (exchangeResponse.ok) {
                    const exchangeData = await exchangeResponse.json();
                    setExchangeRecords(exchangeData.data || []);
                } else {
                    setExchangeRecords([]);
                }
                
                setHasLoaded(true);
            } catch (error) {
                console.error("Error fetching data:", error);
                setHasLoaded(true);
            } finally {
                setIsLoading(false);
            }
        };
        
        fetchData();
    }, []);

    const isDateInRange = (date, range) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const txnDate = new Date(date);
        txnDate.setHours(0, 0, 0, 0);
        
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        
        const lastWeek = new Date(today);
        lastWeek.setDate(lastWeek.getDate() - 7);

        return range === "Today" ? txnDate.getTime() === today.getTime() :
               range === "Yesterday" ? txnDate.getTime() === yesterday.getTime() :
               range === "Last 7 days" ? txnDate >= lastWeek && txnDate <= today : true;
    };

    const filteredRecords = bettingRecords.filter(record => {
        const matchesPlatform = selectedPlatform === "All" || record.platform === selectedPlatform;
        const matchesType = selectedType === "All" || record.game_type === selectedType;
        const matchesDate = isDateInRange(record.created_at, selectedDate);
        return matchesPlatform && matchesType && matchesDate;
    });

    const filteredExchangeRecords = exchangeRecords.filter(record => {
        const matchesPlatform = selectedPlatform === "All" || record.platform === selectedPlatform;
        const matchesType = selectedType === "All" || record.game_type === selectedType;
        const matchesDate = isDateInRange(record.created_at, selectedDate);
        return matchesPlatform && matchesType && matchesDate;
    });
    const handleExpandGroup = (group) => {
        if (expandedGroup && expandedGroup.key === `${group.date}-${group.platform}-${group.game_type}`) {
            setExpandedGroup(null); 
        } else {
            setExpandedGroup({
                key: `${group.date}-${group.platform}-${group.game_type}`,
                records: group.records
            });
        }
    };

    const groupedRecords = filteredRecords.reduce((acc, record) => {
        const date = new Date(record.created_at).toDateString();
        const key = `${date}-${record.platform}-${record.game_type}`;
    
        if (!acc[key]) {
            acc[key] = {
                date,
                platform: record.platform,
                game_type: record.game_type,
                total_bet_amount: 0,
                total_win_amount: 0,
                records: []
            };
        }
    
        acc[key].total_bet_amount += parseFloat(record.bet_amount) || 0;
        acc[key].total_win_amount += parseFloat(record.winAmount) || 0;
        acc[key].records.push(record);
    
        return acc;
    }, {});
    
    

    const groupedExchangeRecords = filteredExchangeRecords.reduce((acc, record) => {
        const date = new Date(record.created_at).toDateString();
        if (!acc[date]) acc[date] = [];
        acc[date].push(record);
        return acc;
    }, {});
    const handleExchangeRecordClick = (record) => {
        setSelectedExchangeRecord(record);
        setShowModal(true);
    };

    
    const closePopup = () => setSelectedExchangeRecord(null);

    // Toggle between tabs in transaction details
    const toggleTab = () => setIsCurrentTab(!isCurrentTab);

    // Helper function to determine CSS class based on status
    const getStatusClass = (status) => {
        if (status === "WON") return "success";
        if (status === "LOST") return "fail";
        if (status === "VOID") return "void";
        if (status === "OPEN" || status === "open") return "processing";
        return "processing";
    };

    // Helper function to get display status text
    const getStatusText = (status) => {
        return status ? status.toUpperCase() : "PROCESSING";
    };

    // Show loading indicator if still loading and haven't loaded yet
    if (isLoading && !hasLoaded) {
        return (
            <div className="main-router-wrapper">
                <header id="header" className="login player">
                    <div className="header-left-btn-group">
                        <UniversalBack />
                    </div>
                    <div className="header-title">Betting Records</div>
                </header>
                <div className="wrap">
                    <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                        <div style={{ fontSize: '18px', color: '#999', marginBottom: '20px' }}>Loading betting records...</div>
                        <div style={{ animation: 'spin 1s linear infinite', display: 'inline-block', fontSize: '30px', color: '#4CAF50' }}>
                            ⟳
                        </div>
                        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main-router-wrapper">
            <header id="header" className="login player">
            <div className="header-left-btn-group">
                {expandedGroup ? (
                    <a 
                    onClick={() => setExpandedGroup(null)} 
                    className="bg-tran"
                    >
                    <div 
                        className="back-btn" 
                        style={{ 
                        maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1729676340443")',
                        WebkitMaskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1729676340443")'
                        }}
                    />
                    </a>
                ) : (
                    <UniversalBack />
                )}
                </div>

                <div className="header-title">Betting Records</div>
                <div className="header-right-btn-group">
                    <a name="helpCenter" className="service-btn">
                        <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/index-theme-icon/header-service-icon.svg?v=1729676340443")' }} />
                    </a>
                </div>
            </header>

            <div className="wrap">
                <div className="content fixed-tab player-content">
                    <div className="tab-btn-section">
                        <div className="tab-btn tab-btn-page">
                            <div className="line" style={{ width: 'calc(50%)', transform: activeTab === "exchange" ? 'translate(100%, 0px)' : 'translate(0%, 0px)' }} />
                            <div className={`btn ${activeTab === "settle" ? "active" : ""}`} onClick={() => setActiveTab("settle")}>
                                <div className="text">Settled</div>
                            </div>
                            <div className={`btn ${activeTab === "exchange" ? "active" : ""}`} onClick={() => setActiveTab("exchange")}>
                                <div className="text">Exchange</div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content tab-content-page">
                        <div className="ng-trigger ng-trigger-tabPageTriggerAni">
                            <div className="ng-trigger ng-trigger-staggerFadeAnimation tab filter-tab">
                                <ul className="item-ani">
                                    <li className="active">{selectedDate}</li>
                                </ul>
                                <div onClick={filterOpen} className="btn search-btn">
                                    <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/index-theme-icon/games-filter-icon.svg?v=1729676340443")' }} />
                                </div>
                            </div>
                            <div className="searchpage">
                                <div onClick={filterClose} className="search-top-info">
                                    <div className="back">
                                        <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1729676340443")' }} />
                                        Back
                                    </div>
                                    <input type="text" className="ng-untouched ng-pristine" placeholder="Betting Record Filter" disabled style={{ backgroundImage: 'url("")' }} />
                                </div>
                                <div className="searchpage-main">
                                    <div className="search-checkbox-group check-group">
                                        <h2>Platform</h2>
                                        <ul>
                                            {providers.map(provider => (
                                                <li key={provider.platform}>
                                                    <input type="checkbox" id={`checkbox-${provider.platform}`} name={provider.platform} 
                                                        onChange={() => setSelectedPlatform(provider.platform === selectedPlatform ? "All" : provider.platform)} 
                                                        checked={selectedPlatform === provider.platform} />
                                                    <label htmlFor={`checkbox-${provider.platform}`}>{provider.platform}</label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="search-checkbox-group check-group">
                                        <h2>Game Type</h2>
                                        <ul>
                                            {gameTypes.map(gameType => (
                                                <li key={gameType}>
                                                    <input type="checkbox" id={`checkbox-${gameType}`} name={gameType} 
                                                        onChange={() => setSelectedType(gameType === selectedType ? "All" : gameType)} 
                                                        checked={selectedType === gameType} />
                                                    <label htmlFor={`checkbox-${gameType}`}>{gameType}</label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="search-checkbox-group check-group">
                                        <h2>Date</h2>
                                        <ul>
                                            <li>
                                                <input type="radio" id="date-today" name="date-filter" 
                                                    onChange={() => setSelectedDate("Today")} 
                                                    checked={selectedDate === "Today"} />
                                                <label htmlFor="date-today">Today</label>
                                            </li>
                                            <li>
                                                <input type="radio" id="date-yesterday" name="date-filter" 
                                                    onChange={() => setSelectedDate("Yesterday")} 
                                                    checked={selectedDate === "Yesterday"} />
                                                <label htmlFor="date-yesterday">Yesterday</label>
                                            </li>
                                            <li>
                                                <input type="radio" id="date-last7days" name="date-filter" 
                                                    onChange={() => setSelectedDate("Last 7 days")} 
                                                    checked={selectedDate === "Last 7 days"} />
                                                <label htmlFor="date-last7days">Last 7 days</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="searchpage-bar">
                                    <button className="button" onClick={filterClose}>Confirm</button>
                                </div>
                            </div>

                            {/* Display betting records or exchange records */}
                            <div className={`${activeTab === "settle" ? 'd-block' : 'd-none'}`}>

                            {expandedGroup && expandedSummary && (
                            <div className="betting-record-sum">
                                <div className="item platform">
                                <div className="title">Platform</div>
                                <div className="text">{expandedSummary.platform}</div>
                                </div>
                                <div className="item type">
                                <div className="title">Game Type</div>
                                <div className="text">{expandedSummary.gameType}</div>
                                </div>
                                <div className="item bet">
                                <div className="title">Turnover</div>
                                <div className="text">{expandedSummary.totalTurnover.toFixed(2)}</div>
                                </div>
                                <div className={`item profit ${expandedSummary.totalProfitLoss < 0 ? 'negative' : ''}`}>
                                <div className="title">Profit/Loss</div>
                                <div className="text">
                                    <i style={{ display: 'initial', color: expandedSummary.totalProfitLoss < 0 ? 'red' : 'white' }}>
                                    ({Math.abs(expandedSummary.totalProfitLoss).toFixed(2)})
                                    </i>
                                </div>
                                </div>
                            </div>
                            )}


                        <div className="inner-wrap">
                            <div className="inner-box">
                            <div className="record-item item-title transaction-record-list">
                                <div className="item type">Platform</div>
                                <div className="item amount">{expandedGroup ? "Game" : "Game Type"}</div>
                                <div className="item status">Turnover</div>
                                <div className="item time">Profit/Loss</div>
                            </div>

                            {Object.keys(groupedRecords).length > 0 ? (
                                (() => {
                                const dateGroups = Object.values(groupedRecords).reduce((acc, group) => {
                                    if (!acc[group.date]) {
                                    acc[group.date] = [];
                                    }
                                    acc[group.date].push(group);
                                    return acc;
                                }, {});

                                
                                if (expandedGroup) {
                                    return (
                                    <div className="list list-betting-record">
                                        <div className="list-content">
                                        {expandedGroup.records.map((record, idx) => {
    const betAmount = parseFloat(record.bet_amount) || 0;
    const winAmount = parseFloat(record.winAmount) || 0;
    const betProfitLoss = winAmount - betAmount;
    const recordDate = new Date(record.created_at).toDateString();

    return (
        <>
        {idx === 0 && (
                <div className="date-title">
                    <div className="date">
                        <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-calendar-type02.svg?v=1730201806250")' }} />
                        {recordDate}
                    </div>
                    <div className="time-zone">GMT+6</div>
                </div>
            )}

        <div key={idx} className="record-item transaction-record-list no-detail-info expanded-item">
            
            

            {/* Record Info */}
            <div className="item platform">{record.platform}</div>
            <div className="item type">
                {record.game_name.length > 15 
                    ? record.game_name.slice(0, 15) + "..." 
                    : record.game_name}
            </div>
            <div className="item bet">{betAmount.toFixed(2)}</div>
            <div className="item profit" style={{ color: betProfitLoss < 0 ? 'red' : 'inherit' }}>
                {Math.abs(betProfitLoss).toFixed(2)}
            </div>
        </div>
        </>
    );
})}

                                        </div>
                                    </div>
                                    );
                                }

                                
                                return Object.keys(dateGroups).map(date => (
                                    <div key={date} className="list list-betting-record">
                                    <div className="date-title">
                                        <div className="date">
                                        <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-calendar-type02.svg?v=1730201806250")' }} />
                                        {date}
                                        </div>
                                        <div className="time-zone">GMT+6</div>
                                    </div>

                                    <div className="list-content">
                                        {dateGroups[date].map((group, index) => {
                                        const profitLoss = (parseFloat(group.total_win_amount) || 0) - (parseFloat(group.total_bet_amount) || 0);

                                        return (
                                            <div key={index} className="record-item transaction-record-list no-detail-info">
                                            <div className="item platform">{group.platform}</div>
                                            <div className="item type">{group.game_type}</div>
                                            <div className="item bet">{(parseFloat(group.total_bet_amount) || 0).toFixed(2)}</div>
                                            <div
                                                className="item profit"
                                                style={{ color: profitLoss < 0 ? 'red' : 'inherit' }}
                                            >
                                                {Math.abs(profitLoss).toFixed(2)}
                                            </div>
                                            <div
                                                className="list-arrow"
                                                style={{
                                                display: 'block',
                                                maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1730201806250")'
                                                }}
                                                onClick={() => handleExpandGroup(group)}
                                            />
                                            </div>
                                        );
                                        })}
                                    </div>
                                    </div>
                                ));
                                })()
                            ) : (
                                <NoData />
                            )}
                            </div>
                        </div>
                        </div>




                            {/* Display exchange records */}
                            <div className={`${activeTab === "exchange" ? 'd-block' : 'd-none'}`}>
                                <div className="inner-wrap">
                                    <div className="inner-box">
                                        <div className="record-item item-title transaction-record-list">
                                            <div className="item type">Platform</div>
                                            <div className="item amount">Game Type</div>
                                            <div className="item status">Turnover</div>
                                            <div className="item time">Profit/Loss</div>
                                        </div>
                                        {Object.keys(groupedExchangeRecords).length > 0 ? (
                                            Object.keys(groupedExchangeRecords).map(date => (
                                                <div key={date} className="list list-exchange-record">
                                                    <div className="date-title">
                                                        <div className="date">
                                                            <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-calendar-type02.svg?v=1730201806250")' }} />
                                                            {date}
                                                        </div>
                                                        <div className="time-zone">GMT+6</div>
                                                    </div>
                                                    <div className="list-content">
                                                        {groupedExchangeRecords[date].map((record, index) => (
                                                            <div key={index} className="record-item transaction-record-list no-detail-info" onClick={() => handleExchangeRecordClick(record)}>
                                                                <div className="item platform"> {record.event_name}</div>
                                                                <div className="item type">
                                                                {record.bet_type}
                                                                </div>


                                                                <div className="item bet">{Math.abs(record.stake)}
                                                                </div>
                                                                <div
                                                                    className={`item`}
                                                                    style={{
                                                                        color: record.status === 'open' ? 'inherit' : (record.status === "WON" ? 'green' : 'red')
                                                                    }}
                                                                    >
                                                                    {Math.abs(record.net_profit_loss)}
                                                                    </div>


                                                                <div className="list-arrow" 
                                                                style={{display: 'block', 
                                                                maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1730201806250")'}} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <NoData />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedExchangeRecord && (
               <>
                <div className="pop-transaction-records-details active">
                   
                    <a onClick={closePopup} className="btn-closed" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1730201806250")' }} />
                    <div className="header">Exchange Record Details</div>
                    <div className={`content pop-content ${getStatusClass(selectedExchangeRecord.status)}`}>
                        <div className="tab-btn-section tab-btn-wrap" onClick={toggleTab}>
                            <div className="tab-btn tab-btn-bar">
                                <div className="line" style={{ width: 'calc(50%)', transform: isCurrentTab ? "translate(0%, 0px)" : "translate(100%, 0px)" }} />
                                <div className="btn" data-tab-current="current">
                                    <img className="icon" alt="icon-timeline" src="https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-timeline.svg?v=1730201806250" loading="lazy" />
                                </div>
                                <div className="btn">
                                    <img className="icon" alt="icon-table" src="https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-table.svg?v=1730201806250" loading="lazy" />
                                </div>
                            </div>
                        </div>
                        <div className="tab-content tab-content-page">
                            <div className="inner-wrap">
                                {/* Progress Tab */}
                                <div className="inner-box" style={{ display: isCurrentTab ? "block" : "none" }}>
                                    <div className="transaction-details-wrap">
                                        <div className="title">
                                            <h3>Exchange Record</h3>
                                            <div className="tags">{getStatusText(selectedExchangeRecord.status)}</div>
                                            
                                        </div>
                                        <div className="details-box">
                                            <div className="info">
                                                <div className="name">Event Name</div>
                                                <div className="value">{selectedExchangeRecord.event_name}</div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Transaction id</div>
                                                <div className="value">{selectedExchangeRecord.transaction_id}</div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Amount</div>
                                                <div className="value">{selectedExchangeRecord.stake}</div>
                                            </div>
                                      </div>
                                       
                                    </div>
                                </div>
                                
                                {/* Details Tab */}
                                <div className="inner-box" style={{ display: !isCurrentTab ? "block" : "none" }}>
                                    <div className="transaction-details-wrap">
                                        <div className="title">
                                            <h3>Exchange Record Details</h3>
                                            <div className="tags">{getStatusText(selectedExchangeRecord.status)}</div>
                                        </div>
                                        <div className="details-box">
                                            <div className="info">
                                                <div className="name">Event Name</div>
                                                <div className="value">{selectedExchangeRecord.event_name}</div>
                                            </div>
                                            
                                            <div className="info">
                                                <div className="name">Game Type</div>
                                                <div className="value">{selectedExchangeRecord.bet_type}</div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Market Name</div>
                                                <div className="value">{selectedExchangeRecord.market_name} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Selection Name</div>
                                                <div className="value">{selectedExchangeRecord.selection_name} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Bet Type</div>
                                                <div className="value">{selectedExchangeRecord.bet_type} </div>
                                            </div>
                                            
                                            <div className="info">
                                                <div className="name">Stake</div>
                                                <div className="value">{selectedExchangeRecord.stake} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Potential Profit</div>
                                                <div className="value">{selectedExchangeRecord.potential_profit} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Potential Liability</div>
                                                <div className="value">{selectedExchangeRecord.potential_liability} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Odds</div>
                                                <div className="value">{selectedExchangeRecord.odds} </div>
                                            </div>
                                            <div className="info">
                                                <div className="name">Runs</div>
                                                <div className="value">{selectedExchangeRecord.run} </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="pop-bg d-block" onClick={closePopup} />
               </>
            )}
        </div>
    );
}

export default BettingRecord;
